/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface PoliticalEntityModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class PoliticalEntityApiService extends SignalAdminResourceApiBase<PoliticalEntityModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'politicalentities');
  }

  listAll(pageSize = 2000): Observable<SignalAdminResourcePage<PoliticalEntityModel>> {
    return this.client.request({
      method: 'GET',
      url: this.resourceUri('politicalentities'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize
      }
    });
  }

  fromAdvertiser(advertiserId: string): Observable<SignalAdminResourcePage<PoliticalEntityModel>> {
    return this.client.request({
      method: 'POST',
      url: this.resourceUri(`politicalentities/fromadvertiser/${encodeURIComponent(advertiserId)}`)
    });
  }
}
